import styled from "styled-components";
import { layout, LayoutProps, space, SpaceProps } from "styled-system";

import { ReactComponent as PlayStoreSvg } from "./google-play-badge.svg";

const Anchor = styled.a<SpaceProps & { css?: string }>`
  display: inline-block;
  ${space}
  ${(props) => props.css}
`;

const StyledSVG = styled(PlayStoreSvg)<LayoutProps>`
  ${layout}
`;

export interface PlayStoreProps extends SpaceProps {
  /**
   * Property a url as a string. The url will ne navigated towards in a new window when clicking the badge
   * Example:  https://play.google.com/store/apps/details?id=com.bca.buyerapp&hl=en_GB
   */
  url: string;
  /**
   *The element's unique identifier
   */
  id?: string;
  /**
   * Property accepts width, value accepted are any css properties plus numbers which will be treated as pixels
   * Examples: "142px", 142, "auto", "100%"
   */
  width?: string | number | (string & (string | number | null)[]);
  css?: string;
  className?: string;
  /**
   * name of the page section in which the element will sit. Used for adobe tracking
   */
  adobeSection?: string;
}

const PlayStoreBadge = ({
  width = "142px",
  url,
  adobeSection,
  ...props
}: PlayStoreProps) => (
  <Anchor
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="play-store-badge"
    data-en="click"
    data-ec="button"
    data-el="playStore"
    data-ea="download"
    data-es={adobeSection}
    {...props}
  >
    <StyledSVG title="Play Store Badge" width={width} />
  </Anchor>
);

export default PlayStoreBadge;
